import script from "./phone-select-footer.vue?vue&type=script&lang=jsx"
export * from "./phone-select-footer.vue?vue&type=script&lang=jsx"

import "./phone-select-footer.vue?vue&type=style&index=0&id=021b12c8&lang=scss"

const __exports__ = script;

export default __exports__